export default __webpack_public_path__ + "static/media/women.9b60159a.png";